import React__default, { useCallback } from 'react';
import { Typography, Card, Space, Icon, Badge } from '@sravni/react-design-system';
import { PhoneDownload } from '@sravni/react-icons';
import { useStyles } from '@sravni/react-utils';
import { useAnalyticEvents } from '../../../hooks/useAnalyticEvents.js';
import DownloadQr from '../images/DownloadQr.png';
import modules_2fceba91 from '../styles/DownloadApp.module.less.js';

const DownloadApp = ({ isMobile }) => {
    const cx = useStyles(modules_2fceba91);
    const cardClassNames = cx('card', {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'h-mt-12': isMobile,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'h-mt-8': !isMobile,
    });
    const titleClassNames = cx('minContent', 'dark', {
        noWrap: isMobile,
    });
    const { pushAnalyticEvent } = useAnalyticEvents();
    const handleClick = useCallback(() => {
        pushAnalyticEvent("downloadApp" /* EVENTS.DOWNLOAD_APP */, {
            eventAction: 'Переход к установке приложения',
            eventLabel: 'Меню профиля|Общая кнопка',
        });
    }, [pushAnalyticEvent]);
    return (React__default.createElement(Typography.Link, { href: "https://www.sravni.ru/analytics-links/v1/redirects/mobileapps/?placement=sravni_lk", onClick: handleClick },
        React__default.createElement(Card, { color: "blue", size: 16, className: cardClassNames },
            React__default.createElement(Space, { align: "center", size: 12 },
                React__default.createElement(Icon, { icon: React__default.createElement(PhoneDownload, null), className: cx('dark') }),
                React__default.createElement(Space, { size: 4, direction: "vertical", justify: "center", className: cx('minContent') },
                    React__default.createElement(Space, { size: isMobile ? 8 : 4, align: isMobile ? 'center' : 'end' },
                        React__default.createElement(Typography.Heading, { level: 5, className: titleClassNames }, "\u0421\u043A\u0430\u0447\u0430\u0439\u0442\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435"),
                        React__default.createElement(Badge, { text: "1", color: "red", variant: "primary", shape: "circle" })),
                    React__default.createElement(Typography.Text, { size: 12, className: cx('text') },
                        "\u0411\u044B\u0441\u0442\u0440\u0430\u044F \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0430 ",
                        isMobile && React__default.createElement(Typography.Link, null, "\u0421\u043A\u0430\u0447\u0430\u0442\u044C"))),
                !isMobile && (React__default.createElement(Space, { justify: "center", align: "center", className: cx('qrWrapper') },
                    React__default.createElement("img", { src: String(DownloadQr), className: cx('qr') })))))));
};

export { DownloadApp };
//# sourceMappingURL=DownloadApp.js.map
